import { render } from "./BenchmarkAndTarget.vue?vue&type=template&id=b302faba&scoped=true"
import script from "./BenchmarkAndTarget.vue?vue&type=script&lang=js"
export * from "./BenchmarkAndTarget.vue?vue&type=script&lang=js"

import "./BenchmarkAndTarget.vue?vue&type=style&index=0&id=b302faba&scoped=true&lang=css"
/* custom blocks */
import block0 from "./BenchmarkAndTarget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b302faba"]])

export default __exports__